<header>
   <div class="global-header-container">
      <div class="global-important">
         <div class="container">
            <div class="important">
               <div class="important-links">
                  <div class="important-links__item"><a
                        href="https://www.miamidade.gov/global/webcasting/home.page">GovMeetings</a></div>
                  <div class="important-links__item"><a
                        href="https://www.miamidade.gov/global/calendar/global.page">Calendar</a></div>
                  <div class="important-links__item"><a href="https://www.miamidade.gov/global/311.page"
                        target="_blank">Contact</a></div>
                  <div class="important-links__item">
                     <a aria-expanded="false" class="dropdown-button btn dropdown-button--language" href="#"
                        data-activates="language2" style="margin-left:0; padding-right: 0;"
                        data-la-node-captured="true">Translate <i aria-hidden="true"
                           class="large material-icons">arrow_drop_down</i></a>
                     <ul id="language2" class="dropdown-content">
                        <li><a href="#googtrans(en|en)" class="lang-en lang-select" data-lang="en">English</a></li>
                        <li><a href="#googtrans(en|es)" class="lang-es lang-select" data-lang="es">Español</a></li>
                        <li><a href="#googtrans(en|ht)" class="lang-es lang-select" data-lang="ht">Kreyòl Ayisyen</a>
                        </li>
                     </ul>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <nav class="site-navigation-container white" role="navigation">
         <div class="nav-wrapper container">
            <div class="global-nav__mobile show-below-1150-only">
               <div class="global-nav__mobile-container">
                  <div class="global-nav__mobile-child"><a href="#" id="mobile-menu" class="left">
                        <div class="mobile-menu-bars"><span></span><span></span><span></span>
                           <div>Menu</div>
                        </div>
                     </a></div>
                  <div class="global-nav__mobile-child"><a href="https://www.miamidade.gov/global/home.page">
                        <img src="https://www.miamidade.gov/resources/global/images/md-logo-color.png"
                           class="md-logo-header-mobile" alt="Miami-Dade County Homepage"></a></div>
                  <div class="global-nav__mobile-child">
                     <div class="log-in-out" style="display: none;">
                        <a id="loginId-mobile" class="loginAPI" href="#">Login</a>
                     </div>
                     <ul class="login-container" style="display: none;">
                        <li class="login-dropdown"><a href="#"><i class="fa fa-user"></i>
                              <span class="sr-only">User Icon Mobile</span></a>
                           <ul>
                              <div class="drop-arrow"></div>
                              <li><a href="#" class="dashBoardAPI">Dashboard</a></li>
                              <li><a href="#" class="updateProfileAPI">Update Profile</a></li>
                              <li><a href="#" class="logoutAPI">Sign Out</a></li>
                           </ul>
                        </li>
                        <li class="link-pip">|</li>
                        <li class="login-dropdown__signout"><a href="#" class="logoutAPI">Sign Out</a></li>
                     </ul><a class="cd-search-trigger-mobile" id="searchMobile"
                        href="#cd-search-mobile">Search<span></span></a>
                  </div>
                  <div id="cd-search-mobile" class="cd-search-mobile">
                     <form
                        action="https://www.miamidade.gov/global/service.page?submit=true&amp;componentID=1563896274059"
                        method="GET" class="mobile-main-search" onsubmit="return q.value!=''"><label
                           class="sr-only mobile-main-search" id="mainMobileSearch">Mobile Search</label><input
                           type="search" name="q" for="mainMobileSearch" aria-labelledby="mainMobileSearch"
                           placeholder="Search miamidade.gov" class="mobile-main-search__search"><input type="submit"
                           value="Submit" class="mobile-main-search__submit btn sr-only"
                           aria-label="Submit your query."></form>
                  </div>
               </div>
            </div>
            <div class="row global-nav__search show-above-1149-only">
               <div class="col s12">
                  <div class="global-nav-container">
                     <a href="https://www.miamidade.gov/global/home.page">
                        <img src="https://www.miamidade.gov/resources/global/images/md-logo-color.png"
                           class="md-logo-header" alt="Miami-Dade County Homepage">
                     </a>
                     <ul class="site-nav-content">
                        <li class="mega-container">
                           <button class="site-navigation__link-button" aria-controls="collapseNavServicesInformation1"
                              aria-expanded="false">
                              Services &amp; Information
                           </button>
                           <ul class="z-depth-1 site-navigation__billboard" id="collapseNavServicesInformation1"
                              aria-hidden="true">
                              <li class="mega-container-child mega-container-child--two-third">
                                 <h3><a href="https://www.miamidade.gov/global/navigation/service-index.page">Interest
                                       Categories</a></h3>
                                 <ul>
                                    <li><a
                                          href="https://www.miamidade.gov/global/navigation/service-index.page?INTERESTCATEGORY=animals-pets">Animals
                                          &amp; Pets</a></li>
                                    <li><a
                                          href="https://www.miamidade.gov/global/navigation/service-index.page?INTERESTCATEGORY=building-development">Building
                                          &amp; Development</a></li>
                                    <li><a
                                          href="https://www.miamidade.gov/global/navigation/service-index.page?INTERESTCATEGORY=business-industry">Business
                                          &amp; Industry</a></li>
                                    <li><a
                                          href="https://www.miamidade.gov/global/navigation/service-index.page?INTERESTCATEGORY=courts-records">Courts
                                          &amp; Records</a></li>
                                    <li><a
                                          href="https://www.miamidade.gov/global/navigation/service-index.page?INTERESTCATEGORY=elections-voting">Elections
                                          &amp; Voting</a></li>
                                    <li><a
                                          href="https://www.miamidade.gov/global/navigation/service-index.page?INTERESTCATEGORY=environment-resilience">Environment
                                          &amp; Resilience</a></li>
                                    <li><a
                                          href="https://www.miamidade.gov/global/navigation/service-index.page?INTERESTCATEGORY=home-property">Home
                                          &amp; Property</a></li>
                                    <li><a
                                          href="https://www.miamidade.gov/global/navigation/service-index.page?INTERESTCATEGORY=housing-social-services">Housing
                                          &amp; Social Services</a></li>
                                    <li><a
                                          href="https://www.miamidade.gov/global/navigation/service-index.page?INTERESTCATEGORY=jobs-employment">Jobs
                                          &amp; Employment</a></li>
                                    <li><a
                                          href="https://www.miamidade.gov/global/navigation/service-index.page?INTERESTCATEGORY=public-safety">Public
                                          Safety</a></li>
                                    <li><a
                                          href="https://www.miamidade.gov/global/navigation/service-index.page?INTERESTCATEGORY=recreation-culture">Recreation
                                          &amp; Culture</a></li>
                                    <li><a
                                          href="https://www.miamidade.gov/global/navigation/service-index.page?INTERESTCATEGORY=travel-transportation">Travel
                                          &amp; Transportation</a></li>
                                    <li class="mega-container-child__button"><a
                                          href="/global/navigation/service-index.page"
                                          class="waves-effect wave-light btn blue">A-Z of Services &amp; Information
                                       </a></li>
                                 </ul>
                              </li>
                              <li class="mega-container-child">
                                 <h3><a href="https://www.miamidade.gov/global/navigation/online-services.page">Online
                                       Services</a></h3>
                                 <ul>
                                    <li><a
                                          href="https://www.miamidade.gov/global/service.page?Mduid_service=ser148069212998189">Bulky
                                          Waste Pickup</a></li>
                                    <li><a href="https://www.miamidade.gov/global/humanresources/jobs/home.page">County
                                          Jobs</a></li>
                                    <li><a
                                          href="https://www.miamidade.gov/global/service.page?Mduid_service=ser1491494549439906">Inmate
                                          Search</a></li>
                                    <li><a href="https://www.miamidade.gov/global/taxcollector/home.page">Pay Taxes</a>
                                    </li>
                                    <li><a
                                          href="https://www.miamidade.gov/global/service.page?Mduid_service=ser1469481154653654">Property
                                          Search</a></li>
                                    <li><a href="https://www.miamidade.gov/global/transportation/transit-pass.page">Transit
                                          Passes</a></li>
                                    <li><a href="https://www.miamidade.gov/global/water/my-account.page">Pay Water
                                          Bill</a></li>
                                    <li class="mega-container-child__button"><a
                                          href="https://www.miamidade.gov/global/navigation/online-services.page"
                                          class="waves-effect wave-light btn blue">View Online Services</a></li>
                                 </ul>
                              </li>
                           </ul>
                        </li>
                        <li class="mega-container"><button class="site-navigation__link-button"
                              aria-controls="collapseNavNewsSocialMedia2" aria-expanded="false">News &amp; Social
                              Media</button>
                           <ul class="z-depth-1 site-navigation__billboard" id="collapseNavNewsSocialMedia2"
                              aria-hidden="true">
                              <li class="mega-container-child mega-container-child--two-third">
                                 <h3><a href="https://www.miamidade.gov/global/navigation/news-index.page">News &amp;
                                       Social Media</a></h3>
                                 <ul>
                                    <li><a href="https://www.miamidade.gov/global/calendar/global.page">Meetings &amp;
                                          Events</a></li>
                                    <li><a
                                          href="https://www.miamidade.gov/global/service.page?Mduid_service=ser1501010041747308">Miami-Dade
                                          TV</a></li>
                                    <li><a href="https://www.miamidade.gov/global/mobile-applications.page">Mobile
                                          Apps</a></li>
                                    <li><a href="https://www.miamidade.gov/global/navigation/prindex.page">Press
                                          Releases</a></li>
                                    <li><a href="https://www.miamidade.gov/global/navigation/legal-ad-index.page">Public
                                          Notices</a></li>
                                    <li><a href="https://www.miamidade.gov/global/social-media.page">Social Media</a>
                                    </li>
                                    <li class="mega-container-child__button"><a
                                          href="https://www.miamidade.gov/global/navigation/news-index.page"
                                          class="waves-effect wave-light btn blue">Read Latest News</a></li>
                                 </ul>
                              </li>
                              <li class="mega-container-child">
                                 <h3><a href="https://accounts.miamidade.gov/uaa/login">Create a new miamidade.gov
                                       account</a></h3>
                                 <div class="mega-container-short-description">
                                    <p>A miamidade.gov profile allows you to link to your Water and Sewer customer
                                       account, as well as subscribe to a variety of news and alert services.</p>
                                    <p>Receive weekly news &amp; events, public notices, recycling reminders, grant
                                       opportunities, emergency alerts, transit rider alerts and more.</p>
                                 </div>
                                 <ul>
                                    <li class="mega-container-child__button"><a
                                          href="https://accounts.miamidade.gov/uaa/login"
                                          class="waves-effect wave-light btn blue">Sign Up Now</a></li>
                                 </ul>
                              </li>
                           </ul>
                        </li>
                        <li class="mega-container"><button class="site-navigation__link-button"
                              aria-controls="collapseNavYourGovernment3" aria-expanded="false">Your Government</button>
                           <ul class="z-depth-1 site-navigation__billboard" id="collapseNavYourGovernment3"
                              aria-hidden="true">
                              <li class="mega-container-child">
                                 <h3><a
                                       href="https://www.miamidade.gov/global/navigation/agency-directory-elected.page">Elected
                                       Officials</a></h3>
                                 <ul>
                                    <li><a href="https://www.miamidade.gov/global/government/mayor/home.page">Office of
                                          the Mayor</a></li>
                                    <li><a href="https://www.miamidade.gov/global/government/commission/home.page">Board
                                          of County Commissioners</a></li>
                                    <li><a href="http://www.miami-dadeclerk.com" target="_blank">Clerk of the Courts</a>
                                    </li>
                                    <li><a href="https://www.miamidade.gov/pa/home.asp">Property Appraiser</a></li>
                                    <li class="mega-container-child__button"><a
                                          href="https://www.miamidade.gov/global/navigation/agency-directory-elected.page"
                                          class="waves-effect wave-light btn blue">A-Z of Elected Officials</a></li>
                                 </ul>
                              </li>
                              <li class="mega-container-child">
                                 <h3><a href="https://www.miamidade.gov/global/navigation/agency-directory.page">County
                                       Agencies</a></h3>
                                 <ul>
                                    <li><a
                                          href="https://www.miamidade.gov/global/navigation/agency-directory-departments.page">Departments</a>
                                    </li>
                                    <li><a
                                          href="https://www.miamidade.gov/global/navigation/agency-directory-offices.page">Offices</a>
                                    </li>
                                    <li><a
                                          href="https://www.miamidade.gov/global/navigation/agency-directory-boards.page">Boards</a>
                                    </li>
                                    <li><a
                                          href="https://www.miamidade.gov/global/navigation/agency-directory-trusts.page">Trusts</a>
                                    </li>
                                    <li class="mega-container-child__button"><a
                                          href="https://www.miamidade.gov/global/navigation/agency-directory.page"
                                          class="waves-effect wave-light btn blue">A-Z of County Agencies</a></li>
                                 </ul>
                              </li>
                              <li class="mega-container-child">
                                 <h3><a href="https://www.miamidade.gov/global/government/transparency/home.page">Transparency
                                       &amp; Open Data </a></h3>
                                 <ul>
                                    <li><a href="https://www.miamidade.gov/global/management/budget/home.page">County
                                          Budget</a></li>
                                    <li><a href="https://www.miamidade.gov/global/elections/home.page">Elections</a>
                                    </li>
                                    <li><a href="https://www.miamidade.gov/global/webcasting/virtual-meeting.page">Government
                                          Meetings</a></li>
                                    <li><a href="https://www.miamidade.gov/govaction/home.asp">Legislative
                                          Information</a></li>
                                    <li><a href="https://www.miamidade.gov/global/publicrecords/search.page">Public
                                          Records</a></li>
                                    <li class="mega-container-child__button"><a
                                          href="https://www.miamidade.gov/global/government/transparency/home.page"
                                          class="waves-effect wave-light btn blue">Search More Data</a></li>
                                 </ul>
                              </li>
                           </ul>
                        </li>
                        <li class="mega-container"><button class="site-navigation__link-button"
                              aria-controls="collapseNavEmployees4" aria-expanded="false">Employees</button>
                           <ul class="z-depth-1 site-navigation__billboard" id="collapseNavEmployees4"
                              aria-hidden="true">
                              <li class="mega-container-child mega-container-child--two-third">
                                 <h3><a href="https://www.miamidade.gov/employee/home.page">Employee Information</a>
                                 </h3>
                                 <ul>
                                    <li><a href="https://www.miamidade.gov/global/humanresources/jobs/home.page">County
                                          Jobs</a></li>
                                    <li><a href="https://www.miamidade.gov/global/humanresources/benefits/home.page">Employee
                                          Benefits</a></li>
                                    <li><a href="https://www.miamidade.gov/employee/discounts.page">Employee
                                          Discounts</a></li>
                                    <li><a
                                          href="https://www.miamidade.gov/global/humanresources/fair-employment/home.page">Human
                                          Rights &amp; Fair Employment</a></li>
                                    <li><a href="/global/humanresources/labor-relations/home.page">Labor Relations</a>
                                    </li>
                                    <li><a href="https://www.miamidade.gov/employee/pay-compensation.page">Pay &amp;
                                          Compensation</a></li>
                                    <li><a href="https://www.miamidade.gov/global/humanresources/training/home.page">Training
                                          &amp; Development</a></li>
                                    <li class="mega-container-child__button"><a
                                          href="https://www.miamidade.gov/employee/home.page"
                                          class="waves-effect wave-light btn blue">Visit Employee Portal</a></li>
                                 </ul>
                              </li>
                              <li class="mega-container-child mega-container-child__image">
                                 <h3><a href="https://www.miamidade.gov/myemployee/home.page">My Employee Portal</a>
                                 </h3>
                                 <div class="mega-container-short-description">
                                    <p>
                                       Employees can login to access personnel information, workplace tools, trainings
                                       and more.
                                    </p>
                                 </div>
                                 <a href="https://www.miamidade.gov/myemployee/home.page"
                                    class="billboard__image__button">
                                    <img src="https://www.miamidade.gov/resources/images/edesktop.jpg"
                                       alt="Graphic of Employee Working">
                                 </a>
                                 <ul>
                                    <li class="mega-container-child__button">
                                       <a href="https://www.miamidade.gov/myemployee/home.page"
                                          class="waves-effect wave-light btn blue">Login to My Employee Portal</a>
                                    </li>
                                 </ul>
                              </li>
                           </ul>
                        </li>
                     </ul>
                     <div class="global-nav__search-container">
                        <div class="cd-search-trigger-desktop" style="display: none;">
                           <a class="cd-search-trigger" id="searchDesktop" href="#cd-search">
                              Search
                              <span>
                              </span>
                           </a>
                           <div class="cd-search-trigger-desktop__arrow"></div>
                        </div>
                        <div id="cd-search" class="cd-search">
                           <form
                              action="https://www.miamidade.gov/global/service.page?submit=true&amp;componentID=1563896274059"
                              method="GET" class="z-depth-1 desktop-main-search" onsubmit="return q.value!=''">
                              <label class="sr-only" id="mainDesktopSearch">Desktop Search</label>
                              <input type="search" name="q" placeholder="Search miamidade.gov"
                                 aria-labelledby="mainDesktopSearch" class="desktop-main-search__search">
                              <input type="submit" value="Submit" class="desktop-main-search__submit btn sr-only"
                                 aria-label="Submit your query.">
                           </form>
                        </div>
                        <div class="log-in-out"><a id="loginId-desktop" class="loginAPI" href="#">
                              <i class="fa fa-sign-in"></i> Login</a></div>
                        <ul class="login-container" style="display: none;">
                           <li class="login-dropdown"><a href="#"><i class="fa fa-user"></i>
                                 <span class="sr-only">User Icon</span></a>
                              <ul>
                                 <div class="drop-arrow"></div>
                                 <li><a href="#" class="dashBoardAPI">Dashboard</a></li>
                                 <li><a href="#" class="updateProfileAPI">Update Profile</a></li>
                                 <li><a href="#" class="logoutAPI">Sign Out</a></li>
                              </ul>
                           </li>
                           <li class="link-pip">|</li>
                           <li class="login-dropdown__signout"><a href="#" class="logoutAPI">Sign Out</a></li>
                        </ul>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </nav>
      <div class="mobile-global-nav" aria-label="Mobile Navigation" aria-hidden="true">
         <div class="mobile-global-nav-container">
            <ul class="mobile-top-menu__tabs">
               <li data-tab="mobile-site" class="mobile-top-menu__tab--active">
                  <div class="mobile-top-menu__tab"><a href="#">Miami-Dade County</a></div>
               </li>
            </ul><button id="mobile-global-close"><svg viewBox="0 0 12 12" role="img" aria-label="Close"
                  focusable="false" style="height: 15px; width: 15px; display: block; fill: rgb(72, 72, 72);">
                  <path fill-rule="evenodd"
                     d="M11.5 10.5c.3.3.3.8 0 1.1-.3.3-.8.3-1.1 0L6 7.1l-4.5 4.5c-.3.3-.8.3-1.1 0-.3-.3-.3-.8 0-1.1L4.9 6 .5 1.5C.2 1.2.2.7.5.4c.3-.3.8-.3 1.1 0L6 4.9 10.5.4c.3-.3.8-.3 1.1 0 .3.3.3.8 0 1.1L7.1 6l4.4 4.5z">
                  </path>
               </svg><span class="sr-only">Close mobile menu</span></button>
            <div class="mobile-content">
               <div class="mobile-content-tab mobile-content-tab--active mobile-content__site-container"
                  id="mobile-site">
                  <ul class="site-nav-content">
                     <li>
                        <button class="site-mobile-navigation__link-button"
                           aria-controls="collapseMobileServicesInformation1" aria-expanded="false">
                           Services &amp; Information
                        </button>
                        <ul class="site-navigation__billboard" id="collapseMobileServicesInformation1"
                           aria-hidden="true">
                           <li class="mega-container-child mega-container-child--two-third">
                              <h3><a href="https://www.miamidade.gov/global/navigation/service-index.page">Interest
                                    Categories</a></h3>
                              <ul>
                                 <li><a
                                       href="https://www.miamidade.gov/global/navigation/service-index.page?INTERESTCATEGORY=animals-pets">Animals
                                       &amp; Pets</a></li>
                                 <li><a
                                       href="https://www.miamidade.gov/global/navigation/service-index.page?INTERESTCATEGORY=building-development">Building
                                       &amp; Development</a></li>
                                 <li><a
                                       href="https://www.miamidade.gov/global/navigation/service-index.page?INTERESTCATEGORY=business-industry">Business
                                       &amp; Industry</a></li>
                                 <li><a
                                       href="https://www.miamidade.gov/global/navigation/service-index.page?INTERESTCATEGORY=courts-records">Courts
                                       &amp; Records</a></li>
                                 <li><a
                                       href="https://www.miamidade.gov/global/navigation/service-index.page?INTERESTCATEGORY=elections-voting">Elections
                                       &amp; Voting</a></li>
                                 <li><a
                                       href="https://www.miamidade.gov/global/navigation/service-index.page?INTERESTCATEGORY=environment-resilience">Environment
                                       &amp; Resilience</a></li>
                                 <li><a
                                       href="https://www.miamidade.gov/global/navigation/service-index.page?INTERESTCATEGORY=home-property">Home
                                       &amp; Property</a></li>
                                 <li><a
                                       href="https://www.miamidade.gov/global/navigation/service-index.page?INTERESTCATEGORY=housing-social-services">Housing
                                       &amp; Social Services</a></li>
                                 <li><a
                                       href="https://www.miamidade.gov/global/navigation/service-index.page?INTERESTCATEGORY=jobs-employment">Jobs
                                       &amp; Employment</a></li>
                                 <li><a
                                       href="https://www.miamidade.gov/global/navigation/service-index.page?INTERESTCATEGORY=public-safety">Public
                                       Safety</a></li>
                                 <li><a
                                       href="https://www.miamidade.gov/global/navigation/service-index.page?INTERESTCATEGORY=recreation-culture">Recreation
                                       &amp; Culture</a></li>
                                 <li><a
                                       href="/global/navigation/service-index.page?INTERESTCATEGORY=travel-transportation">Travel
                                       &amp; Transportation</a></li>
                                 <li class="mega-container-child__button"><a
                                       href="https://www.miamidade.gov/global/navigation/service-index.page"
                                       class="waves-effect wave-light btn blue">A-Z of Services &amp; Information </a>
                                 </li>
                              </ul>
                           </li>
                           <li class="mega-container-child">
                              <h3><a href="https://www.miamidade.gov/global/navigation/online-services.page">Online
                                    Services</a></h3>
                              <ul>
                                 <li><a
                                       href="https://www.miamidade.gov/global/service.page?Mduid_service=ser148069212998189">Bulky
                                       Waste Pickup</a></li>
                                 <li><a href="https://www.miamidade.gov/global/humanresources/jobs/home.page">County
                                       Jobs</a></li>
                                 <li><a
                                       href="https://www.miamidade.gov/global/service.page?Mduid_service=ser1491494549439906">Inmate
                                       Search</a></li>
                                 <li><a href="https://www.miamidade.gov/global/taxcollector/home.page">Pay Taxes</a>
                                 </li>
                                 <li><a
                                       href="https://www.miamidade.gov/global/service.page?Mduid_service=ser1469481154653654">Property
                                       Search</a></li>
                                 <li><a href="https://www.miamidade.gov/global/transportation/transit-pass.page">Transit
                                       Passes</a></li>
                                 <li><a href="https://www.miamidade.gov/global/water/my-account.page">Pay Water Bill</a>
                                 </li>
                                 <li class="mega-container-child__button"><a
                                       href="https://www.miamidade.gov/global/navigation/online-services.page"
                                       class="waves-effect wave-light btn blue">View Online Services</a></li>
                              </ul>
                           </li>
                        </ul>
                     </li>
                     <li><button class="site-mobile-navigation__link-button"
                           aria-controls="collapseMobileNewsSocialMedia2" aria-expanded="false">News &amp; Social
                           Media</button>
                        <ul class="site-navigation__billboard" id="collapseMobileNewsSocialMedia2" aria-hidden="true">
                           <li class="mega-container-child mega-container-child--two-third">
                              <h3><a href="https://www.miamidade.gov/global/navigation/news-index.page">News &amp;
                                    Social Media</a></h3>
                              <ul>
                                 <li><a href="https://www.miamidade.gov/global/calendar/global.page">Meetings &amp;
                                       Events</a></li>
                                 <li><a
                                       href="https://www.miamidade.gov/global/service.page?Mduid_service=ser1501010041747308">Miami-Dade
                                       TV</a></li>
                                 <li><a href="https://www.miamidade.gov/global/mobile-applications.page">Mobile Apps</a>
                                 </li>
                                 <li><a href="https://www.miamidade.gov/global/navigation/prindex.page">Press
                                       Releases</a></li>
                                 <li><a href="https://www.miamidade.gov/global/navigation/legal-ad-index.page">Public
                                       Notices</a></li>
                                 <li><a href="https://www.miamidade.gov/global/social-media.page">Social Media</a></li>
                                 <li class="mega-container-child__button"><a
                                       href="https://www.miamidade.gov/global/navigation/news-index.page"
                                       class="waves-effect wave-light btn blue">Read Latest News</a></li>
                              </ul>
                           </li>
                           <li class="mega-container-child">
                              <h3><a href="https://accounts.miamidade.gov/uaa/login">Create a new miamidade.gov
                                    account</a></h3>
                              <div class="mega-container-short-description">
                                 <p>A miamidade.gov profile allows you to link to your Water and Sewer customer account,
                                    as well as subscribe to a variety of news and alert services.</p>
                                 <p>Receive weekly news &amp; events, public notices, recycling reminders, grant
                                    opportunities, emergency alerts, transit rider alerts and more.</p>
                              </div>
                              <ul>
                                 <li class="mega-container-child__button">
                                    <a href="https://accounts.miamidade.gov/uaa/login"
                                       class="waves-effect wave-light btn blue">Sign Up Now</a>
                                 </li>
                              </ul>
                           </li>
                        </ul>
                     </li>
                     <li><button class="site-mobile-navigation__link-button"
                           aria-controls="collapseMobileYourGovernment3" aria-expanded="false">Your Government</button>
                        <ul class="site-navigation__billboard" id="collapseMobileYourGovernment3" aria-hidden="true">
                           <li class="mega-container-child">
                              <h3><a href="https://www.miamidade.gov/global/navigation/agency-directory-elected.page">Elected
                                    Officials</a></h3>
                              <ul>
                                 <li><a href="https://www.miamidade.gov/global/government/mayor/home.page">Office of the
                                       Mayor</a></li>
                                 <li><a href="https://www.miamidade.gov/global/government/commission/home.page">Board of
                                       County Commissioners</a></li>
                                 <li><a href="http://www.miami-dadeclerk.com" target="_blank">Clerk of the Courts</a>
                                 </li>
                                 <li><a href="https://www.miamidade.gov/pa/home.asp">Property Appraiser</a></li>
                                 <li class="mega-container-child__button"><a
                                       href="/global/navigation/agency-directory-elected.page"
                                       class="waves-effect wave-light btn blue">A-Z of Elected Officials</a></li>
                              </ul>
                           </li>
                           <li class="mega-container-child">
                              <h3><a href="https://www.miamidade.gov/global/navigation/agency-directory.page">County
                                    Agencies</a></h3>
                              <ul>
                                 <li><a
                                       href="https://www.miamidade.gov/global/navigation/agency-directory-departments.page">Departments</a>
                                 </li>
                                 <li><a
                                       href="https://www.miamidade.gov/global/navigation/agency-directory-offices.page">Offices</a>
                                 </li>
                                 <li><a
                                       href="https://www.miamidade.gov/global/navigation/agency-directory-boards.page">Boards</a>
                                 </li>
                                 <li><a
                                       href="https://www.miamidade.gov/global/navigation/agency-directory-trusts.page">Trusts</a>
                                 </li>
                                 <li class="mega-container-child__button"><a
                                       href="https://www.miamidade.gov/global/navigation/agency-directory.page"
                                       class="waves-effect wave-light btn blue">A-Z of County Agencies</a></li>
                              </ul>
                           </li>
                           <li class="mega-container-child">
                              <h3><a href="https://www.miamidade.gov/global/government/transparency/home.page">Transparency
                                    &amp; Open Data </a></h3>
                              <ul>
                                 <li><a href="https://www.miamidade.gov/global/management/budget/home.page">County
                                       Budget</a></li>
                                 <li><a href="https://www.miamidade.gov/global/elections/home.page">Elections</a></li>
                                 <li><a href="https://www.miamidade.gov/global/webcasting/virtual-meeting.page">Government
                                       Meetings</a></li>
                                 <li><a href="https://www.miamidade.gov/govaction/home.asp">Legislative Information</a>
                                 </li>
                                 <li><a href="/global/publicrecords/search.page">Public Records</a></li>
                                 <li class="mega-container-child__button"><a
                                       href="https://www.miamidade.gov/global/government/transparency/home.page"
                                       class="waves-effect wave-light btn blue">Search More Data</a></li>
                              </ul>
                           </li>
                        </ul>
                     </li>
                     <li><button class="site-mobile-navigation__link-button" aria-controls="collapseMobileEmployees4"
                           aria-expanded="false">Employees</button>
                        <ul class="site-navigation__billboard" id="collapseMobileEmployees4" aria-hidden="true">
                           <li class="mega-container-child mega-container-child--two-third">
                              <h3><a href="https://www.miamidade.gov/employee/home.page">Employee Information</a></h3>
                              <ul>
                                 <li><a href="https://www.miamidade.gov/global/humanresources/jobs/home.page">County
                                       Jobs</a></li>
                                 <li><a href="https://www.miamidade.gov/global/humanresources/benefits/home.page">Employee
                                       Benefits</a></li>
                                 <li><a href="https://www.miamidade.gov/employee/discounts.page">Employee Discounts</a>
                                 </li>
                                 <li><a
                                       href="https://www.miamidade.gov/global/humanresources/fair-employment/home.page">Human
                                       Rights &amp; Fair Employment</a></li>
                                 <li><a
                                       href="https://www.miamidade.gov/global/humanresources/labor-relations/home.page">Labor
                                       Relations</a></li>
                                 <li><a href="https://www.miamidade.gov/employee/pay-compensation.page">Pay &amp;
                                       Compensation</a></li>
                                 <li><a href="https://www.miamidade.gov/global/humanresources/training/home.page">Training
                                       &amp; Development</a></li>
                                 <li class="mega-container-child__button"><a
                                       href="https://www.miamidade.gov/employee/home.page"
                                       class="waves-effect wave-light btn blue">Visit Employee Portal</a></li>
                              </ul>
                           </li>
                           <li class="mega-container-child mega-container-child__image">
                              <h3><a href="https://www.miamidade.gov/myemployee/home.page">My Employee Portal</a></h3>
                              <div class="mega-container-short-description">
                                 <p>Employees can login to access personnel information, workplace tools, trainings and
                                    more.</p>
                              </div><a href="/myemployee/home.page" class="billboard__image__button"><img
                                    src="/resources/images/edesktop.jpg" alt="Graphic of Employee Working"></a>
                              <ul>
                                 <li class="mega-container-child__button"><a
                                       href="https://www.miamidade.gov/myemployee/home.page"
                                       class="waves-effect wave-light btn blue">Login to My Employee Portal</a></li>
                              </ul>
                           </li>
                        </ul>
                     </li>
                  </ul>
               </div>
            </div>
         </div>
      </div>
   </div>
</header>